import { CommonResponse } from "@gtpl/shared-models/masters";
import connection from "./connection";
import axios from "axios";
import { DateRangeReq } from "@gtpl/shared-models/analytics-data";
import { ProductionProcessDashboardReq } from "@gtpl/shared-models/production-management";


export class MainDashboardService {
    URL = connection.DEPLOY_URL + '/mainDashboard';
    async getEnquiresStatusWiseCount(req:DateRangeReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEnquiresStatusWiseCount',req)
            .then(res => {
                return res.data
            })
    }

    async getRawMaterialInward(req:DateRangeReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRawMaterialInward',req)
            .then(res => {
                return res.data
            })
    }

    async getMonthWiseSaleOrders(req:DateRangeReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getMonthWiseSaleOrders',req)
            .then(res => {
                return res.data
            })
    }

    async getStockCount(req:DateRangeReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getStockCount',req)
            .then(res => {
                return res.data
            })
    }

    async getDetailStock(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDetailStock')
            .then(res => {
                return res.data
            })
    }

    async getTotalProductionForDashboard(req?:ProductionProcessDashboardReq): Promise <CommonResponse> {
        return await axios.post(this.URL + '/getTotalProductionForDashboard',req)
            .then(res => {
                return res.data
            })
    }

    async getDeadStock(): Promise <CommonResponse> {
        return await axios.post(this.URL + '/getDeadStock')
            .then(res => {
                return res.data
            })
    }

    async getAntibioticTestResult():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAntibioticTestResult')
        .then(res => {
            return res.data
        })
}

async getTodayArrivalQty():Promise<CommonResponse>{
    return await axios.post(this.URL + '/getTodayArrivalQty')
    .then(res => {
        return res.data
    })
}

async getSaleOrdersData(req: DateRangeReq):Promise<CommonResponse>{
    return await axios.post(this.URL + '/getSaleOrdersData', req).then(res => {
        return res.data
    })
}

async getSaleOrdersDetailData(req: DateRangeReq):Promise<CommonResponse>{
    return await axios.post(this.URL + '/getSaleOrdersDetailData', req).then(res => {
        return res.data
    })
}
async getSupllierTypeWiseData():Promise<CommonResponse>{
    return await axios.post(this.URL + '/getSupllierTypeWiseData').then(res => {
        return res.data
    })
}
}